import React, { Component, useEffect, useState } from "react";
import Sketch from "react-p5";
import { v4 as uuid } from 'uuid';
import { DEFAULT_MAPPING, DENSITY_MAPPINGS, FONT } from "./AsciiArt";
import "./p5.css";

// const IMAGE = "assets/asciiart/grandma_and_papa.png"
const IMAGE = "house_logo.png"

export default function AsciiVideo({densityMapping}) {
  const [canvas, setCanvas] = useState(<></>);
  useEffect(() => {
    setCanvas(<AsciiArtCanvas key={uuid()} densityMapping={densityMapping} />);

    return (() => {
      setCanvas(<></>)
    })
  }, [densityMapping]);

  return canvas;
}

class AsciiArtCanvas extends Component {
  constructor(props){
    super(props);
    this.densityMapping = props.densityMapping ? DENSITY_MAPPINGS[props.densityMapping] : DENSITY_MAPPINGS[DEFAULT_MAPPING];
  }

  image;
  asciiDiv;

  preload(p5) {
    this.image = p5.loadImage(IMAGE);
  }

  setup = (p5, parent) => {
    // const screenWidth = p5.windowWidth;
    // const screenHeight = p5.windowHeight;
    // const charWidth = 10; // hard coded; seems about right
    // const charHeight = 26; // hard coded; seems about right
    
    p5.noCanvas();
    this.image.loadPixels();
    // this.video.size(screenWidth / charWidth, screenHeight / charHeight);
    this.asciiDiv = p5.createDiv();
    this.asciiDiv.parent(parent);
    this.asciiDiv.style("font-family", FONT);
    this.asciiDiv.style("color", "#fff");
    this.asciiDiv.style("background-color", "#000");
    this.asciiDiv.style("z-index", 0);
    this.asciiDiv.style("margin-top", "48px");

    let asciiImage = "";
    for (let j = 0; j < this.image.height; j++) {
      for (let i = 0; i < this.image.width; i++) {
        const column = this.densityMapping.flip ? this.video.width - 1 - i : i;
        const pixelIndex = (column + j * this.video.width) * 4;
        const r = this.video.pixels[pixelIndex + 0];
        const g = this.video.pixels[pixelIndex + 1];
        const b = this.video.pixels[pixelIndex + 2];
        const averageBrightness = (r + g + b) / 3;
        const charIndex = p5.floor(
          p5.map(averageBrightness, 0, 255, this.densityMapping.alphabet.length, 0)
        );
        const charToAdd = this.densityMapping.alphabet.charAt(charIndex);
        charToAdd === " " ? (asciiImage += "\xa0") : (asciiImage += charToAdd);
      }
      asciiImage += "<br/>";
      this.asciiDiv.html(asciiImage);
    }
  };

  render() {
    return <Sketch preload={this.preload} setup={this.setup} />;
  }
}